import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { SvgSelector } from '../../../assets/icons/svg-selector';
export const ProfileHeader = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (_jsx("div", { className: "relative px-5", children: _jsxs("div", { className: "flex items-center justify-between gap-[15px] py-[15px]", children: [_jsx("button", { onClick: () => navigate(-1), children: _jsx(SvgSelector, { id: "back" }) }), _jsx("h3", { className: "text-sm leading-7 text-center text-[#3A4362]", children: t('profile.title') }), _jsx("button", { onClick: () => navigate(-1), children: _jsx(SvgSelector, { id: "edit" }) })] }) }));
};
